import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  withCredentials: true, // kirim httpOnly cookie di setiap request
});

API.interceptors.request.use((config) => {
  // Fallback: jika masih ada token di localStorage (migrasi), sertakan juga
  const token = localStorage.getItem('ki_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Bersihkan localStorage legacy
      localStorage.removeItem('ki_token');
      localStorage.removeItem('ki_user');
      const url = error.config?.url || '';
      const isAuthCheck = url.includes('/auth/me') || url.includes('/auth/refresh');
      if (
        !isAuthCheck &&
        !window.location.pathname.includes('/login') &&
        !window.location.pathname.includes('/register') &&
        !window.location.pathname.includes('/verify-email')
      ) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Resolve URL foto relatif (/uploads/...) ke absolute URL
export const resolvePhoto = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  const base = process.env.REACT_APP_UPLOADS_URL || '';
  return `${base}${url}`;
};

// Kapitalkan huruf awal tiap kata pada nama author → Title Case penuh
// (huruf pertama kapital, sisanya kecil): 'aNDI saPUTRA' → 'Andi Saputra'
export const formatAuthorName = (name) => {
  if (!name) return name;
  return name
    .split(/\s+/)
    .map(w => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(' ');
};

// Estimasi waktu baca (menit) dari konten HTML — 200 kata/menit
export const readingMinutes = (html) => {
  if (!html) return 1;
  const text = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  const words = text ? text.split(' ').length : 0;
  return Math.max(1, Math.round(words / 200));
};

export default API;
